module.exports = __webpack_public_path__ + "static/media/solvemoji_cover_hard_master.14563e98.jpg";